import { Component, OnInit, TemplateRef, ChangeDetectorRef, AfterViewInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global"; 
import { HttpClient, HttpParams } from "@angular/common/http";
import { DatePipe } from "@angular/common" 
import { EChartsOption } from "echarts";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import * as CONSTANT from "../../../services/constants";
import { ExcelService } from "src/app/services/excel.service";

@Component({
  selector: "app-user-activity",
  templateUrl: "./user-activity.component.html",
  styleUrls: ["./user-activity.component.css"]
})
export class UserActivityComponent implements OnInit {
  allData:any;
  maxDate: Date;
  today: Date;
  invalidDateFilter = false;
  fromDate: any;
  toDate: any;
  show = 0;
  filterForm: FormGroup;
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  showError = false;
  currentPage=1;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}

  constructor( public route: ActivatedRoute,  private router: Router, private api: AdminService, public datePipe: DatePipe, private formBuilder: FormBuilder,private modalService: BsModalService, private ref:ChangeDetectorRef,private excelService:ExcelService) {  
    this.filterForm = this.formBuilder.group({
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
    });
    this.today = new Date();
    this.maxDate = new Date(this.today.getDate() + 3);
  } 
  ngOnInit(): void {
    this.getUsersReport();  
  }
   
  getUsersReport(){
    let params = new HttpParams();
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.fromDate) {
      params = params.append("startDate", this.fromDate);
    }
    if (this.toDate) {
      params = params.append("endDate", this.toDate);
    } 
    this.api.getData(apiUrl._userReport,params)
    .subscribe(async (res) => { 
      this.pagination.totalItems = res.data.totalCount; 
      this.allData = res.data;   
    })
  }  
  
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getUsersReport();
  }
  openModal(template: TemplateRef<any>) {
    this.modalService.show(template);
  }
  close() {
    this.modalRef?.hide();
  }
  
  applyFilter(modal: any) {
    this.fromDate = this.datePipe.transform(
      this.filterForm.value.startDate,
      "yyyy-MM-dd"
    );
    this.toDate = this.datePipe.transform(
      this.filterForm.value.endDate,
      "yyyy-MM-dd"
    );
    if (this.filterForm.valid) {
      if (this.fromDate && this.toDate) {
        if (this.fromDate > this.toDate) {
          this.invalidDateFilter = true;
          setTimeout(() => {
            this.invalidDateFilter = false;
          }, 4000);
          return;
        }
      }
      this.getUsersReport();
      this.show = 1;
      this.modalService.hide();
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 3000);
      return;
    }
  }

  clearFilter(modal: any) {
    this.filterForm.reset();
    this.fromDate = "";
    this.toDate = "";
    this.show = 0;
    this.modalRef?.hide();
    this.modalService.hide();
    this.getUsersReport();
  }

  // download Csv file
  downloadCsv(){
    let excelData: any;  
    let dataToSend:any = []
    let allData:any = [] 
    let params = new HttpParams(); 
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.fromDate) {
      params = params.append("startDate", this.fromDate);
    }
    if (this.toDate) {
      params = params.append("endDate", this.toDate);
    } 
    this.api.getData(apiUrl._userReport,params)
    .subscribe(async (res) => {
      
      let allData = res.data.list;
      allData.map(val=>{
      const data = {
        FullName: val?.recruiterDetails?.name,
        EmailId: val?.recruiterDetails?.email,
        InventoryUsed: val?.inventoryUsed,
        ResumeView: val?.resumeView,
        ForwardResume: val?.forwardResume,
        DownloadResume: val?.downloadResume,
        SentDirectEmail: val?.sentDirectEmail,
        Searches: val?.searches,
        EmailOpened: val?.emailOpen,
        CandidateClick: val?.candidateClicks,
        EmailOpenClickRate: (val?.emailOpen/val?.sentDirectEmail)*100 > 0 ? (val?.emailOpen/val?.sentDirectEmail)*100  : "0" + "%",
        CandidateClickRate: (val?.candidateClicks/this.allData?.totalInvetoryPlan)*100 > 0 ? (val?.candidateClicks/this.allData?.totalInvetoryPlan)*100 : "0" + "%",
      }
      dataToSend.push(data)
    })
    excelData = dataToSend;
    console.log(excelData);
    
   this.excelService.exportAsExcelFile(excelData, "Inventory used by month");
    });
   
  }
}
